import { all } from 'redux-saga/effects';
import rootSaga from './components/common/redux/sagas';

export function* sagas() {
  yield all([
    rootSaga(),
  ]);
}

export default sagas;
